/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ic_home': {
    width: 41,
    height: 41,
    viewBox: '0 0 41 41',
    data: '<path pid="0" d="M1.708 37.583v-20.91a3.417 3.417 0 011.454-2.794l16.357-11.48a1.708 1.708 0 011.963 0l16.356 11.48a3.416 3.416 0 011.454 2.794v20.91a1.708 1.708 0 01-1.709 1.709h-9.11a1.709 1.709 0 01-1.709-1.709V27.89a1.708 1.708 0 00-1.708-1.708h-9.112a1.709 1.709 0 00-1.709 1.708v9.693a1.708 1.708 0 01-1.708 1.709h-9.11a1.709 1.709 0 01-1.709-1.709z" _stroke="#B4C2EA" stroke-opacity=".9" stroke-width="3.417"/>'
  }
})
